/*global WDPRO, performance*/
(function (P, $) {
    'use strict';

    var config = { // these are the fall back defaults when not overridden by mergeConfig
            authCookieIncludeSubDomains: true,
            authCookieName: 'pep_oauth_token',
            authTimeout: 600,
            authURL: '/authentication/get-client-token/',
            enableResourceTiming: true,
            longTimeoutEnabled: true,
            personalizationIdCookieJarName: 'personalization_jar',
            personalizationIdCookieName: 'id',
            logAjaxCommands: ['getAuthToken', 'fetchPersonalizations']
        };

    $(document).ajaxSend(function (event, jqXHR, ajaxSettings) {
        ajaxSettings.startTime = new Date().getTime();

        jqXHR.then(ajaxDoneHandler, ajaxDoneHandler);

        function ajaxDoneHandler() {
            ajaxSettings.endTime = new Date().getTime();
        }
    });

    $(document).ajaxComplete(function (event, jqXHR, ajaxSettings) {
        var logData,
            message,
            resourceTimings;

        if (config.logAjaxCommands.indexOf(ajaxSettings.command) < 0) {
            return;
        }

        logData = {
            url: ajaxSettings.url,
            responseTime: ajaxSettings.endTime - ajaxSettings.startTime
        };

        if (config.enableResourceTiming && window.performance  && window.performance.getEntriesByType) {
            resourceTimings = performance.getEntriesByType('resource').filter(function (timing) {
                return timing.name.indexOf(ajaxSettings.url) > -1;
            });
            if (resourceTimings.length) {
                logData.resourceTiming  = resourceTimings[resourceTimings.length - 1];
            }
        }

        if (jqXHR.state() === 'resolved') {
            message = '\'' + ajaxSettings.command + '\' call succeeded: ';
        } else {
            message = '\'' + ajaxSettings.command + '\' call failed: ';

            logData.errorThrown = jqXHR.textStatus;
            logData.responseHeaders = jqXHR.getAllResponseHeaders();
            logData.status = jqXHR.status;
            logData.textStatus = jqXHR.textStatus;
        }

        P.Debug.logRemote(message, logData);
    });

    P.Utils = {
        /**
         *
         * Appends addition request params per service requirements to an object.  also returns the object
         *
         * @param {Object} base the object to modify
         *
         * @returns {Object} the modified object
         */
        appendParams: function (base) {
            var FL_RESIDENT_AFFILIATION = 'Florida Resident',
                attributes = [],
                dataLayer = P.dataLayer,
                isFlResident,
                personalizationId = this.getPersonalizationId();

            attributes.add = function (name, value) {
                this[this.length] = {
                    name: name,
                    value: value
                };
            };
            if ($.isPlainObject(base)) {
                if (personalizationId) {
                    base.personalizationId = personalizationId;
                }

                if (dataLayer) {
                    if (dataLayer.age) {
                        attributes.add('age', dataLayer.age);
                    }
                    if (dataLayer.geo) {
                        if (dataLayer.geo.country) {
                            attributes.add('geolocation-country', dataLayer.geo.country);
                        }
                        if (dataLayer.geo.dmaCode) {
                            attributes.add('geolocation-dma', dataLayer.geo.dmaCode);
                        }
                        if (dataLayer.geo.region) {
                            attributes.add('geolocation-region', dataLayer.geo.region);
                        }
                    }
                    if (dataLayer.guestAffiliations) {
                        isFlResident = dataLayer.guestAffiliations.split(',').map(function (affiliation) {
                            return $.trim(affiliation);
                        }).indexOf(FL_RESIDENT_AFFILIATION) > 0;
                        attributes.add('guest-affiliations-fl-res', isFlResident);
                    }
                    if (dataLayer.customerId && dataLayer.customerId !== '') {
                        attributes.add('swid', dataLayer.customerId);
                    }
                }
                if (window && window.location) {
                    attributes.add('page-url', window.location.pathname + window.location.search);
                }
                if (document && document.referrer) {
                    attributes.add('referrer', document.referrer);
                }
                if (navigator && navigator.userAgent) {
                    attributes.add('user-agent', navigator.userAgent);
                }

                base.channel = 'web';
                base.events = [
                    {
                        attributes: attributes,
                        datetime: new Date().toISOString(),
                        eventType: 'd-decision-request'
                    }
                ];
            }

            return base;
        },
        /**
         *
         * Reads the data layer object from the DOM
         *
         * @returns {Object}
         */
        getDataLayer: function () {
            try {
                return $.parseJSON(atob($('[data-analytics]').attr('data-analytics')))[0];
            } catch (e) {
                return null;
            }
        }, // function getDataLayer
        /**
         *
         * Fetches the auth token and caches it does not get fetched excessively
         *
         * @returns {Object} Promise (string) with the authToken string
         */
        getAuthToken: function () {
            var authToken = authToken || this.getCookie(config.authCookieName),// attempt to fetch the value from cookie
                deferred = $.Deferred(), // the promise to return
                url = config.authURL; // url for the service to hit in case we need a new token

            if (authToken) {
                deferred.resolve(authToken);
            } else {
                $.ajax({
                    beforeSend: function (xhr) {
                        P.ajaxCall = xhr;
                    },
                    contentType: 'application/json',
                    dataType: 'json',
                    timeout: config.longTimeoutEnabled ? 0 : config.authTimeout,
                    type: 'GET',
                    url: url,
                    command: 'getAuthToken'
                }).then(
                    function getAuthTokenSuccess(data) {
                        var domain, // domain to use in saving the authToken to a cookie
                            hostname = window.location.hostname.toString(); // current hostname

                        if (hostname !== 'localhost') {
                            domain = (config.authCookieIncludeSubDomains ? '.' : '') + hostname;
                        }

                        P.Utils.setCookie(
                            config.authCookieName,
                            /*jshint camelcase: false */
                            data.access_token,
                            data.expires_in,
                            /*jshint camelcase: true */
                            '/',
                            domain,
                            (window.location.protocol === 'https:' ? true : false)
                        );

                        /*jshint camelcase: false */
                        deferred.resolve(data.access_token);
                        /*jshint camelcase: true */
                    },
                    function getAuthTokenFailure() {
                        deferred.reject();
                    }
                );
            }

            return deferred.promise();
        }, // function getAuthToken
        /**
         *
         * Fetch a cookie
         *
         * @param {string} cookie - the name of the cookie to fetch
         * @param {boolean} decode - toggle to JSON decode the value
         *
         * @returns {string}
         */
        getCookie: function (cookie, decode) {
            var re = new RegExp(cookie + '=([^;]+)'), // dynamic regex to parse document.cookie for the one you want
                value = re.exec(document.cookie); // the value out of the regex

            value = (value !== null) ? decodeURIComponent(value[1]) : null;
            if (decode) {
                value = JSON.parse(value);
            }

            return value;
        }, // function getCookie
        /**
         *
         * retrieves a value from a JSON object at a specific address
         *
         * @param {Object} parsed - a parsed JSON object
         * @param {string} address - the address of the property to find ie. key.sub.property
         *
         * @returns {*|undefined}
         */
        getJsonKey: function (parsed, address) {
            return address.split('.').reduce(function (node, prop) {
                if (node) {
                    return node[prop];
                }
            }, parsed);
        }, // function getJsonKey
        /**
         *
         * Read the pageKey from the DOM
         *
         * @returns {string}
         */
        getPageKey: function () {
            return $('meta[name="pageKey"]').attr('content');
        }, // function getPageKey
        /**
         *
         * Fetch the personalizationId from the cookie
         *
         * @returns {string | Null}
         */
        getPersonalizationId: function () {
            var cookieJar, // reference to cookie jar
                id = null; // the value to return

            cookieJar = this.getCookie(config.personalizationIdCookieJarName);
            if (cookieJar) {
                id = JSON.parse(cookieJar)[config.personalizationIdCookieName];
            }

            return id;
        }, // function getPersonalizationId
        mergeConfig: function (overrides) {
            $.extend(config, overrides);
        }, // function mergeConfig

        pollForElement: pollForElement,

        /**
         *
         * wraps the result of a promise in a resolved promise in order to be able to collect both
         *   rejected and fulfilled
         *      pollForElement calls in a when call, since when calls fire on all resolved or the first failed.
         *      There are times when we want a when call to fire when all settled (fulfilled | rejected)
         *
         * @param {*} info - additional data to pass through
         * @param {Promise} promise - to be wrapped and returned as resolved.
         * @param {*} selector - selector data to pass through
         *
         * @returns {Object}
         */
        pollForElementStatus: function (info, promise, selector) {
            var newPromise = $.Deferred();

            promise.then(
                function (value) {
                    newPromise.resolve({ info: info, selector: selector, status: 'resolved', value: value });
                },
                function (value) {
                    newPromise.resolve({ info: info, selector: selector, status: 'rejected', value: value });
                }
            );

            return newPromise;
        }, // function pollForElementStatus

        race: promiseRace,
        afterReadyPromise: afterReadyPromise,

        /**
         * convert string/int value to boolean value
         *
         * @param {string|int} value - value to be converted to boolean
         *
         * @returns {boolean}
         */
        getBoolean: function (obj) {
            if (obj && (obj === true || obj === 'true' || obj === '1' || obj === 1)) {
                return true;
            }

            return false;
        }, // function getBoolean
        /**
         *
         * Set a cookie
         *
         * @param {string} sKey - the cookie name
         * @param {Object|string} sValue - the value to write in the cooke.  If Object, set jsonEncode = true
         * @param {Date|number|string} vEnd - when the cookie should expire.  Number is seconds from now.
         * @param {string} [sPath] - the path to target the cookie to
         * @param {string} [sDomain] - the domain to target the cookie to
         * @param {boolean} [bSecure] - limit the cookie to HTTPS
         * @param {boolean} [jsonEncode] - should we JSON.stringify the value
         *
         * @returns {boolean}
         */
        setCookie: function (sKey, sValue, vEnd, sPath, sDomain, bSecure, jsonEncode) {
            var sExpires = '';

            if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                return false;
            }

            if (vEnd) {
                switch (vEnd.constructor) {
                    case Number:
                        sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
                        break;
                    case String:
                        sExpires = '; expires=' + vEnd;
                        break;
                    case Date:
                        sExpires = '; expires=' + vEnd.toUTCString();
                        break;
                }
            }

            if (jsonEncode) {
                sValue = JSON.stringify(sValue);
            }

            document.cookie = encodeURIComponent(sKey) + '=' +
                encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
            return true;
        }, // function setCookie
        /**
         *
         * set the personalizationId into storage to use later or for others to use
         *
         * @param {string} personalizationId - the value
         */
        setPersonalizationId: function (personalizationId) {
            var now = new Date(),
                oneYr = new Date(),
                cookieJar,
                cookieName,
                cookieVal,
                domain = window.location.hostname.toString(),
                encodeJSON = false;

            oneYr.setFullYear(now.getFullYear() + 1);

            if (domain === 'localhost') {
                domain = null;
            }

            if (config.personalizationIdCookieJarName && config.personalizationIdCookieName) {
                cookieJar = this.getCookie(config.personalizationIdCookieJarName);
                if (cookieJar) {
                    cookieVal = JSON.parse(cookieJar);
                } else {
                    cookieVal = {};
                }
                encodeJSON = true;
                cookieVal[config.personalizationIdCookieName] = personalizationId;
                cookieName = config.personalizationIdCookieJarName;
            } else if (!config.personalizationIdCookieJarName && config.personalizationIdCookieName) {
                cookieName = config.personalizationIdCookieName;
                cookieVal = personalizationId;
            } else {
                cookieName = 'personalization_jar';
                encodeJSON = true;
                cookieJar = this.getCookie(cookieName);
                if (cookieJar) {
                    cookieVal = JSON.parse(cookieJar);
                } else {
                    cookieVal = {};
                }
                cookieVal = personalizationId;
            }

            P.Utils.setCookie(
                cookieName,
                cookieVal,
                oneYr.toUTCString(),
                '/',
                domain,
                (window.location.protocol === 'https:' ? true : false),
                encodeJSON
            );
        } // function setPersonalizationId
    };

    /**
     *
     * Repeatedly check for element to exist so we can execute a callback with payload on the element.
     * Stops checking when page load complete
     *
     * @param {string} selector - a jQuery selector
     * @param {boolean} lastCall - is this the final time checking
     *
     * @return {promise} promise is fullfilled when element is found, and rejected after domReady
     */
    function pollForElement(selector, timeout, elementDeferred, comboDeferred) {
        var $elm = $(selector), // the element you are looking for
            intervalMs = 50; // interval to repeatedly poll for element

        elementDeferred = elementDeferred || $.Deferred();
        if ($elm.length > 0) {
            elementDeferred.resolve($elm);
        }

        comboDeferred = comboDeferred || promiseRace(elementDeferred, afterReadyPromise(timeout));
        if (comboDeferred.state() === 'pending') {
            setTimeout(pollForElement.bind(null, selector, timeout, elementDeferred, comboDeferred), intervalMs);
        }

        return comboDeferred.promise();
    }



    /**
     *
     * returns a promise that resolves or rejects with the result of the first promise to resolve or reject
     *
     * @param {Promise} promise1 - the first contestant in the race
     * @param {Promise} promise2 - the second contestant in the race
     *
     * @returns {Promise}
     */
    function promiseRace(promise1, promise2) {
        var deferred = $.Deferred();
        promise1.then(deferred.resolve, deferred.reject);
        promise2.then(deferred.resolve, deferred.reject);
        return deferred.promise();
    }

    /**
     *
     * returns a promise that rejects on domready or after a timeout after domready
     *
     * @param {int} [timeout] - the number of milliseconds after domready to reject
     *
     * @returns {Promise}
     */
    function afterReadyPromise(timeout) {
        var deferred = $.Deferred();
        $(timeout ? setTimeout.bind(window, deferred.reject, timeout) : deferred.reject);
        return deferred.promise();
    }

}(WDPRO.Personalization, WDPRO.Personalization.$));
